import { render, staticRenderFns } from "./VeJwBjggCheckModal.vue?vue&type=template&id=be72ddb2"
import script from "./VeJwBjggCheckModal.vue?vue&type=script&lang=js"
export * from "./VeJwBjggCheckModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports